<template>
<div>
  <div class="stepper">
    <template v-for="(step, index) in overTrafficAlertSteps">
      <div class="circle" :class="{ active: index <= currentStep }">{{ index + 1 }}</div>
      <div v-if="index < overTrafficAlertSteps.length - 1" class="line" :class="{ active: index < currentStep }"></div>
    </template>
  </div>

  <div>
    <div v-if="currentStep === 0">
      <div v-if="!overTrafficAlertSteps[currentStep].isChecked" class="row">
        <div class="col-md-12">
          <h6 class="d-flex justify-content-center">{{ overTrafficAlertSteps[currentStep].title }}</h6>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-8 flex-column">
          <div class="form-group">
            <legend class="col-form-label">Send Email To:
            </legend>
            <div  class="row pl-15 pr-15 mt-10">
              <div class="col-md-4 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedOption" type="radio" id="inputDomain" value="test"> Test Email
                  <span class="form-check-sign"></span>
                </label>
              </div>
              <div class="col-md-6 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedOption" type="radio" id="status" value="client"> Client Email
                  <span class="form-check-sign"></span>
                </label>
              </div>
            </div>
            <div v-if="selectedOption === 'test'" class="form-group">
              <label>Test Email</label>
              <input v-model="email.emailTo" class="form-control" type="text">
            </div>
          </div>
          <button class="btn btn-outline-info btn-sm pull-right" :disabled="syncLoading"  @click="sendEmail(currentStep)">
            <div class="loader mini_loader" v-if="syncLoading"></div>
            <span v-else>Submit</span>
          </button>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 d-flex flex-column justify-content-center align-items-center">
          <div class="checkmark">
            <i class="fa fa-check-circle"></i>
          </div>

          <div class="step-completion-info d-flex flex-column justify-content-center align-items-center">
            <p><strong>Step 1 Complete!</strong></p>
            <p class="info-line">The first email alert for notifying about the over traffic situation has been successfully sent to the customer.</p>
            <p class="info-line">Email Sent By: <b>{{ overTrafficAlertSteps[currentStep].checkedBy }}</b></p>
            <p class="info-line">Email Sent At: <b>{{ formatDate(overTrafficAlertSteps[currentStep].checkedAt) }}</b></p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentStep === 1">
      <div v-if="!overTrafficAlertSteps[currentStep].isChecked" class="row">
        <div class="col-md-12">
          <h6 class="d-flex justify-content-center">{{ overTrafficAlertSteps[currentStep].title }}</h6>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-8 flex-column">
          <div class="form-group">
            <legend class="col-form-label">Send Email To:
            </legend>
            <div  class="row pl-15 pr-15 mt-10">
              <div class="col-md-4 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedOption" type="radio" id="inputDomain" value="test"> Test Email
                  <span class="form-check-sign"></span>
                </label>
              </div>
              <div class="col-md-6 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedOption" type="radio" id="status" value="client"> Client Email
                  <span class="form-check-sign"></span>
                </label>
              </div>
            </div>
            <div v-if="selectedOption === 'test'" class="form-group">
              <label>Test Email</label>
              <input v-model="email.emailTo" class="form-control" type="text">
            </div>
          </div>
          <button class="btn btn-outline-info btn-sm pull-right" :disabled="syncLoading"  @click="sendEmail(currentStep)">
            <div class="loader mini_loader" v-if="syncLoading"></div>
            <span v-else>Submit</span>
          </button>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 d-flex flex-column justify-content-center align-items-center">
          <div class="checkmark">
            <i class="fa fa-check-circle"></i>
          </div>

          <div class="step-completion-info d-flex flex-column justify-content-center align-items-center">
            <p><strong>Step {{currentStep + 1}} Complete!</strong></p>
            <p class="info-line">The {{currentStep === 0 ? 'first' : 'second'}} email alert for notifying about the over traffic situation has been successfully sent to the customer.</p>
            <p class="info-line">Email Sent By: <b>{{ overTrafficAlertSteps[currentStep].checkedBy }}</b></p>
            <p class="info-line">Email Sent At: <b>{{ formatDate(overTrafficAlertSteps[currentStep].checkedAt) }}</b></p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentStep === 2">
      <div v-if="!overTrafficAlertSteps[currentStep].isChecked" class="row">
        <div class="col-md-12">
          <h6 class="d-flex justify-content-center">{{ overTrafficAlertSteps[currentStep].title }}</h6>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-8 flex-column">
          <div class="form-group">
            <legend class="col-form-label">Send Text Message To:
            </legend>
            <div  class="row pl-15 pr-15 mt-10">
              <div class="col-md-4 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedOptionForText" type="radio" id="inputDomain" value="test"> Test No.
                  <span class="form-check-sign"></span>
                </label>
              </div>
              <div class="col-md-6 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedOptionForText" type="radio" id="status" value="client"> Client No.
                  <span class="form-check-sign"></span>
                </label>
              </div>
            </div>
            <div v-if="selectedOptionForText === 'test'" class="form-group">
              <label>Test No.</label>
              <input v-model="text.number" class="form-control" type="text">
            </div>
            <div v-else-if="selectedOptionForText === 'client'" class="form-group">
              <label>Client No.</label>
              <input v-model="text.number" class="form-control" type="text">
            </div>
            <div class="form-group">
              <label>Message:</label>
              <textarea class="form-control" v-model="text.message" name="message" id="" rows="10"></textarea>
            </div>

          </div>
          <button class="btn btn-outline-info btn-sm pull-right" :disabled="syncLoading"  @click="sendEmail(currentStep)">
            <div class="loader mini_loader" v-if="syncLoading"></div>
            <span v-else>Submit</span>
          </button>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 d-flex flex-column justify-content-center align-items-center">
          <div class="checkmark">
            <i class="fa fa-check-circle"></i>
          </div>

          <div class="step-completion-info d-flex flex-column justify-content-center align-items-center">
            <p><strong>Step {{currentStep + 1}} Complete!</strong></p>
            <p class="info-line">The third sms alert for notifying about the over traffic situation has been successfully sent to the customer.</p>
            <p class="info-line">Email Sent By: <b>{{ overTrafficAlertSteps[currentStep].checkedBy }}</b></p>
            <p class="info-line">Email Sent At: <b>{{ formatDate(overTrafficAlertSteps[currentStep].checkedAt) }}</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <button class="btn btn-sm btn-primary" @click="prevStep" :disabled="currentStep === 0">Back</button>
    <button class="btn btn-sm btn-danger" :disabled="!overTrafficAlertSteps[currentStep].isChecked" v-if="currentStep < overTrafficAlertSteps.length - 1" @click="nextStep">Next</button>
<!--    <button class="btn btn-sm btn-primary" v-else @click="finish">Finish</button>-->
  </div>
</div>
</template>
<script>
import {db} from "@/firebase/init";
import moment from "moment";

export default {
  props: ['overTrafficAlertSteps', 'selectedData', 'updatedHtml'],
  data() {
    return {
      text: {
        number: '+923158977208',
        message: ''
      },
      currentStep: 0,
      email: {sendTo: 'test', history: [], emailTo: 'sara@bigscoots.com'},
      selectedOption: 'test',
      selectedOptionForText: 'test',
      syncLoading: false,

    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY hh:mm A");
    },
    async sendEmail(step) {
      try {
        console.log(`emil data ${this.selectedData}`)
        this.syncLoading = true
        if(this.currentStep === 0 || this.currentStep === 1){
          const response = await this.$http.post('/traffic/send-email-for-over-traffic', {
            html: this.updatedHtml,
            grant_type: 'token',
            message: '',
            subject: '',
            trafficData: {
              "goodBots": this.selectedData.totalGoodBots,
              "badBots": this.selectedData.totalBadBots,
              "maliciousBots": this.selectedData.totalMaliciousBots,
              "uniqueVisits": this.selectedData.billable,
              "total": this.selectedData.totalVisitors
            },
            isEmailForClient: true,
            name: this.selectedData.name,
            emailTo: this.selectedOption === 'test' ? 'sara@bigscoots.com' : ''
          });
          console.log(`response from api ${response.data}`)
          if(step === 0 || step === 1) {
            this.overTrafficAlertSteps[this.currentStep].isChecked = true;
            this.overTrafficAlertSteps[this.currentStep].checkedBy = `${this.user.firstName} ${this.user.lastName}`;
            this.overTrafficAlertSteps[this.currentStep].checkedAt = new Date().toISOString();
            this.selectedData.logs.push({
              date: new Date().toISOString(),
              log: `Step ${this.currentStep + 1} for sending email about overage traffic alert has been executed by ${this.user.firstName} ${this.user.lastName} at ${moment().tz('America/New_York').format('MMM DD YYYY, hh:mm A')} EST.`,
            })
            await db.collection('overTrafficBilling').doc(this.selectedData.id).update({
              status: 'running',
              steps: this.overTrafficAlertSteps,
              updatedAt: new Date().toISOString(),
              logs: this.selectedData.logs
            })
            this.currentStep++
          }
          this.showToast({message: 'You have successfully sent email!' , duration: 2000}, true, 'success')
        } else if(this.currentStep === 2) {
          // const response = await this.$http.post("twilio/send-message", {
          //   grant_type: "token",
          //   to: this.text.number,
          //   uid: this.selectedData.uid,
          //   message: this.text.message,
          //   username: this.selectedData.name,
          //   email: this.selectedData.email,
          //   sender: this.user.firstName + ' ' + this.user.lastName,
          //   clientId: '7652'
          // });
          // console.log('response from api ' + response.data)
          this.showToast({message: 'You have successfully sent text message!' , duration: 5000}, true, 'success')
          this.overTrafficAlertSteps[this.currentStep].isChecked = true;
          this.overTrafficAlertSteps[this.currentStep].checkedBy = `${this.user.firstName} ${this.user.lastName}`;
          this.overTrafficAlertSteps[this.currentStep].checkedAt = new Date().toISOString();
          this.selectedData.logs.push({
            date: new Date().toISOString(),
            log: `Step ${this.currentStep + 1} for sending text message about overage traffic alert has been executed by ${this.user.firstName} ${this.user.lastName} at ${moment().tz('America/New_York').format('MMM DD YYYY, hh:mm A')} EST.`,
          })
          await db.collection('overTrafficBilling').doc(this.selectedData.id).update({
            steps: this.overTrafficAlertSteps,
            updatedAt: new Date().toISOString(),
            logs: this.selectedData.logs,
          })
        }
      } catch (e) {
        this.showToast({message: 'Something went wrong while sending email!' , duration: 2000}, true, 'danger')
      } finally {
        if(this.selectedOption === 'client') {
          this.email = { sendTo: 'test' };
          // $('#emailModal').modal('hide');
        }
      }
      this.syncLoading = false
    },
    nextStep() {
      if (this.currentStep < this.overTrafficAlertSteps.length - 1) {
        this.currentStep++;
      }
      if(this.currentStep === 2) {
        this.text.message = `Hi ${this.selectedData.name}!, 👋

Your website has been performing incredibly well, and your traffic and resource growth shows just how much your audience values your content. 🎉

However, we've noticed your site is nearing—or has exceeded—your current plan's traffic limit. To keep your site fast, secure, and fully optimized for your visitors, now is the perfect time to upgrade your hosting plan. Proactively staying ahead of your resource needs ensures your site continues to deliver exceptional speed and reliability around the clock.`
      }
    },
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    finish() {
      alert('Wizard complete!');
      this.currentStep = 0;
    },
  }
}
</script>
<style scoped>

</style>